<template>
    <div class="create-wedding-list">
        <h3 class="text-center">{{ step }} / 3</h3>
        <section v-if="step === 1" class="wedding-step1">
            <div class="wedding-header-block">
                <h1 class="wedding-header">{{ $t('wishlist.weddingCreate.congratulations') }}</h1>
                <div class="wedding-divider"></div>
                <h1 class="wedding-header">{{ $t('wishlist.weddingCreate.whatIsYourName') }}</h1>
            </div>

            <section class="wedding-name">
                <b-input :placeholder="$t('wishlist.weddingCreate.firstName')" v-model="form.meta.person1.firstName"/>
                <b-input :placeholder="$t('wishlist.weddingCreate.lastName')" v-model="form.meta.person1.lastName"/>
            </section>
            <b-button
                :disabled="stepDone(1)"
                @click="step = 2"
                variant="primary"
                block
            >
                {{ $t('wishlist.weddingCreate.nextButton') }}
            </b-button>
        </section>
        <section v-else-if="step === 2" class="wedding-step2">
            <h1 class="wedding-header">{{ $t('wishlist.weddingCreate.whatIsYourPartnersName') }}</h1>
            <section class="wedding-name">
                <b-input :placeholder="$t('wishlist.weddingCreate.firstName')" v-model="form.meta.person2.firstName"/>
                <b-input :placeholder="$t('wishlist.weddingCreate.lastName')" v-model="form.meta.person2.lastName"/>
            </section>
            <b-button
                :disabled="stepDone(2)"
                @click="step = 3"
                variant="primary"
                block
            >
                {{ $t('wishlist.weddingCreate.nextButton') }}
            </b-button>
            <b-button variant="black" @click="step = 1" block>{{ $t('wishlist.weddingCreate.goBack') }}</b-button>
        </section>
        <section v-else-if="step === 3" class="wedding-step3">
            <h1 class="wedding-header">{{ $t('wishlist.weddingCreate.whichLocationAndDate') }}</h1>
            <div class="wedding-name">
                <b-input :placeholder="$t('wishlist.weddingCreate.location')" v-model="form.location"/>
                <my-date-field v-model="form.date"></my-date-field>
            </div>
            <b-button
                :disabled="stepDone(3)"
                block
                variant="primary"
                @click="submitCreate"
            >Skapa bröllopslista
            </b-button>
            <b-button variant="black" @click="step = 2" block>{{ $t('wishlist.weddingCreate.goBack') }}</b-button>
        </section>
    </div>
</template>
<script>
import { defineComponent } from 'vue';
import WishlistDetails from '@components/Wishlist/WishlistDetails.vue';
import { useWishlistStore } from '@stores/Wishlist';
import MainWithAside from '@components/Account/MainWithAside.vue';
import PageTitle from '@components/Typography/PageTitle.vue';
import AlignRight from '@components/Layout/AlignRight.vue';
import MyDateField from '@components/Form/MyDateField.vue';
import { useAppStore } from '@stores/App';

export default defineComponent({
    components: {
        AlignRight,
        PageTitle,
        MainWithAside,
        WishlistDetails,
        MyDateField,
    },
    data() {
        return {
            id: null,
            loading: true,
            exist: true,
            step: 1,
            form: {
                meta: {
                    person1: {
                        firstName: null,
                        lastName: null,
                    },
                    person2: {
                        firstName: null,
                        lastName: null,
                    },
                },
                location: null,
                date: null,
            },
        };
    },
    computed: {
        title() {
            return this.wishlist?.name;
        },
    },
    async mounted() {
        this.loading = true;
        try {
            const wishlist = useWishlistStore();
            await wishlist.getWeddingList();
            this.exist = true;
        } catch (e) {
            if (e.response.status === 404) {
                this.exist = false;
            }
        }
        this.loading = false;
    },
    methods: {
        stepDone(step) {
            if (step === 1) {
                const person1 = this.form.meta.person1;
                return !(!!person1.firstName && !!person1.lastName);
            }

            if (step === 2) {
                const person2 = this.form.meta.person2;
                return !(!!person2.firstName && !!person2.lastName);
            }

            if (step === 3) {
                return !(!!this.form.location && !!this.form.date);
            }

            return false;
        },
        async submitCreate() {
            const wishlist = useWishlistStore();
            try {
                const response = await wishlist.createWeddingList(
                    this.$t('wishlist.weddingListFormName'),
                    this.form,
                );
                location.href = '/account/wedding-list';
            } catch (e) {
                console.error(e);
            }
        },
        deleted() {
            this.$router.push({ path: `/account/lists` });
        },
    },
});
</script>
<style lang="scss" scoped>
h3 {
    font-family: Chronicle, serif;
    font-weight: 100;
}

.create-wedding-list {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    min-height: 700px;
    padding: 4rem 2rem;
    max-width: 600px;
    margin: 0 auto;
    width: 100%;
}

.wedding-header {
    font-size: 24px;
    text-align: center;
}

.wedding-header-block {
    margin: 3rem 0;
}

.wedding-divider {
    margin: 2rem auto;
    border-bottom: 1px solid #000000;
    max-width: 200px;
}

.wedding-name {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 1rem;
}

::v-deep .form-control {
    background: transparent;
    border: 0;
    border-bottom: 1px solid #000000;
    color: #000000;

    &::placeholder {
        color: #000000;
        opacity: 0.6;
    }
}

::v-deep .btn {
    margin-top: 4rem;
}
</style>
